const REPORTS_DOMAIN = 'reports'

const REPORTS_KEY = {
  ALL: 'all',
  DATA: 'data'
}

const REPORTS_PATH = {
  DATA: `${REPORTS_DOMAIN}.${REPORTS_KEY.DATA}`,
  ALL: `${REPORTS_DOMAIN}.${REPORTS_KEY.ALL}`,
  ALL_DATA: `${REPORTS_DOMAIN}.${REPORTS_KEY.ALL}.data`
}

const REPORTS_STATE = {
  [REPORTS_KEY.ALL]: {
    data: [],
    status: null
  },
  [REPORTS_KEY.DATA]: {}
}

const REPORTS_ACTION = {
  LOAD: 'REPORTS_LOAD'
}

const REPORTS_ANALYTICS_EVENT = {
  LOADED: 'Reports Loaded'
}

const REPORTS_ENDPOINT = {
  REPORTS: '/reports'
}

export {
  REPORTS_DOMAIN,
  REPORTS_KEY,
  REPORTS_PATH,
  REPORTS_STATE,
  REPORTS_ACTION,
  REPORTS_ANALYTICS_EVENT,
  REPORTS_ENDPOINT
}
